import { render, staticRenderFns } from "./Awacs.vue?vue&type=template&id=582d7037&"
import script from "./Awacs.vue?vue&type=script&lang=js&"
export * from "./Awacs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports